<template>
    <div class="main">

        <div class="loginBox">
            <div class="top">
                <div class="mainTit">{{sysName}}</div>
            </div>
            <div class="loginForm">
                <div class="loginTit">登录系统</div>
                <el-form ref="form" :model="loginForm" label-width="40px">
                    <el-form-item :label="$t('login.account')">
                        <el-input class="logInt" v-model="loginForm.userAccount" :placeholder="$t('login.account')" size="big" type="text"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('login.password')">
                        <el-input class="logInt" v-model="loginForm.password" :placeholder="$t('login.password')" size="big" type="password" show-password @keyup.enter.native="login()"></el-input>
                    </el-form-item>
                </el-form>
                <el-button @click="login" type="primary" class="loginBtn">{{$t('login.btn')}}</el-button>
            </div>
            <div class="clear0"></div>
        </div>
        <div class="copyRights">
            <!-- Copyright © 2025 江苏数心智能科技有限公司版权所有. All Rights Reserved.<br /><br /> -->
            <!-- <a class="crLink" href="https://www.miit.gov.cn/" target="_blank">苏ICP备2023030000号-1</a> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
            sysName: config.sysName,
            loginForm: {
                userAccount: '',
                password: '',
                sysId: 'mar',
            },
        };
    },
    methods: {
        login: function () {
            let _this = this;
            this.req('/common/backend_login', this.loginForm, function (data) {
                if (data.success) {
                    _this.initUserData(data.obj);
                } else {
                    _this.$message.error(data.message);
                }
            })
        },
        initUserData: function (data) {
            let _this = this;
            sessionStorage.setItem("uid", data.id);
            sessionStorage.setItem("type", data.type);
            sessionStorage.setItem("userName", data.userName);
            sessionStorage.setItem("avatar", data.avatar ? data.avatar : '');
            sessionStorage.setItem("menuArr", JSON.stringify(data.authMenus));
            sessionStorage.setItem("funsArr", data.authFuns);

            this.$router.push("/");
        },
        resize: function () {
            let h = document.body.clientHeight;
            let mt = (h - 550) / 2 - 30;
            if (mt < 0) {
                mt = 0;
            }
            this.mt = mt;
        },
        ckNewVersion: function () {
            this.req('/common/qry_web_version', {}, function (data) {
                if (data.success) {
                    let newVersion = data.obj.split(',')[0];
                    let locVersion = localStorage.getItem('qnbVersion');
                    localStorage.setItem('qnbVersion', newVersion);

                    if (locVersion && newVersion != locVersion) {
                        window.location.reload(true);
                    }
                }
            }, 'get')
        },

    },
    mounted: function () {
        this.$nextTick(function () {
            console.log("mounted login -- >");
            let _this = this;
            this.ckNewVersion();

            this.resize();
            window.addEventListener('resize', () => {
                _this.resize();
            });
        });
    }
};
</script>

<style scoped>
.main {
    height: 100%;
    background-image: url("/static/images/pic/bg1.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: calc(50vh - 180px);
}
.mainTit {
    font-weight: 600;
    font-size: 36px;
    color: #fff;
    text-align: center;
    margin-top: -50px;
}
.mt1 {
    height: 20%;
}
.copyRights {
    padding-top: 50px;
    font-size: 14px;
    font-weight: 300;
    color: #fff;
    text-align: center;
}
.mt1 {
    height: 15%;
}

.loginBox {
    width: 900px;
    margin: auto;
}

.top {
    width: 500px;
    height: 350px;
    background-image: url("/static/images/pic/wait1.png");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    /* background-color: #077cf5; */
    /* background-image: linear-gradient(to bottom, rgba(101,16,173,0.8), rgba(101,16,173,0.5),  rgba(255,255,255,1)); */
    text-align: center;
    /* color: #077cf5; */
    float: left;
}

.loginForm {
    width: 350px;
    float: right;
    padding-top: 0px;
}

.loginTit{
    font-size: 30px;
    color: #fff;
    text-align: center;
    margin-bottom: 40px;
}

.loginBtn {
    width: 100%;
    box-sizing: border-box;
    border-radius: 20px;
    margin-top: 20px;
}

.logInt >>> input:-internal-autofill-selected {
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(255, 255, 255, 0) !important;
}

.logInt >>> input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(255, 255, 255, 0) !important;
}

.logInt >>> input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s;
    background-color: rgba(255, 255, 255, 0) !important;
}

.crLink {
    text-decoration: none;
    color: #077cf5;
    padding-left: 10px;
}

.loginForm /deep/ .el-form-item__label{
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue